import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import FlagIcon from "vue-flag-icon";
import axios from "axios";
import store from "./store";
import i18n from "@/plugins/i18n";
import Swal from "sweetalert2";
import VueCookies from "vue-cookies";
import VueZxingScanner from "vue-zxing-scanner";
import "@/assets/styles/alerts.css";

Vue.prototype.$http = axios;
axios.defaults.headers.common["Content-Type"] = "application/json";

const token = localStorage.getItem("Token");
const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
if (token && isLoggedIn) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

let isTokenHandling = false;
axios.interceptors.response.use(
  (response) => {
    if (response.data?.status === 4 && !isTokenHandling) {
      handleSessionExpired();
    }
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const msg = error?.response?.data?.message || error.message || "";

    const isExpired =
      status === 401 ||
      msg.includes("Token หมดอายุ") ||
      msg.includes("Your session has expired") ||
      msg.includes("Session Expired");

    if (isExpired && !isTokenHandling) {
      handleSessionExpired();
    }
    return Promise.reject(error);
  }
);

function handleSessionExpired() {
  if (isTokenHandling) return;

  isTokenHandling = true;

  localStorage.removeItem("Token");
  localStorage.removeItem("isLoggedIn");
  delete axios.defaults.headers.common["Authorization"];

  Swal.fire({
    icon: "warning",
    title: "Session หมดอายุ",
    text: "กรุณาเข้าสู่ระบบใหม่",
    confirmButtonText: "OK",
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(() => {
    isTokenHandling = false;

    if (router.currentRoute.path !== "/Login") {
      router.replace("/Login");
    }
  });
}

window.$ = window.jQuery = require("jquery");
Vue.config.productionTip = false;
Vue.use(FlagIcon);
Vue.use(VueCookies);
Vue.use(VueZxingScanner);
new Vue({
  i18n,
  vuetify,
  store,
  router,
  Swal,
  render: (h) => h(App),
}).$mount("#app");
